// Mock data for Michango App Landing Page

export const mockData = {
  app: {
    name: "Michango App",
    tagline: "Simplify Event Planning & Contributions",
    description: "The ultimate platform to manage group contributions for events, trips, and celebrations. Share directly to WhatsApp and make planning effortless and transparent.",
    playStoreUrl: "https://play.google.com/store/apps/details?id=app.michango.android",
    features: [
      "Real-time contribution tracking",
      "WhatsApp sharing integration", 
      "Group event planning",
      "Invitation Cards processing"
    ]
  },
  services: [
    {
      id: 1,
      title: "Event Contribution Management",
      description: "Seamlessly collect and track contributions from group members for any event or occasion.",
      icon: "Users"
    },
    {
      id: 2,
      title: "WhatsApp Integration",
      description: "Share contribution requests and updates directly to WhatsApp groups with one tap.",
      icon: "MessageCircle"
    },
    {
      id: 3,
      title: "Invitation Card Processing",
      description: "Process your Invitation cards easily and easily share as Images with scannable codes or SMS.",
      icon: "Shield"
    },
    {
      id: 4,
      title: "Real-time Updates",
      description: "Get instant notifications and share progress updates with your WhatsApp groups.",
      icon: "Zap"
    }
  ],
  contact: {
    email: "info@michango.app",
    phone: "+255 741 400 600",
    address: "Dar es Salaam, Tanzania",
    coordinates: {
      lat: -6.755284960585175,
      lng: 39.28267628251677
    },
    businessHours: "Monday - Friday: 9:00 AM - 6:00 PM"
  },
  testimonials: [
    {
      id: 1,
      name: "Sarah Massawe",
      role: "Event Organizer",
      content: "Michango App made organizing our company retreat so much easier. The WhatsApp sharing feature kept everyone updated instantly!",
      rating: 5
    },
    {
      id: 2,
      name: "David Mayunga",
      role: "Wedding Planner",
      content: "Being able to share contribution requests directly to our WhatsApp group saved us so much time. No more awkward money conversations!",
      rating: 5
    }
  ],
  stats: {
    activeUsers: "10,000+",
    eventsManaged: "5,000+",
    totalContributions: "$2M+"
  }
};

// Mock function to simulate waitlist signup
export const mockWaitlistSignup = (phoneNumber) => {
  const whatsappNumber = "+255741400600";
  const message = `I am waiting for iOS App my number is ${phoneNumber}`;
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

  // Open WhatsApp in a new tab
  window.open(whatsappUrl, "_blank");

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: "WhatsApp chat opened successfully!"
      });
    }, 500);
  });
};

